import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"

const RecordSpoilage = ({ toggle, visible, store, record, onPerform }) => {
    const [quantity, setQty] = useState()
    const [description, setDesc] = useState()

    const modify = e => {
        switch (e.target.name) {
            case 'qty':
                setQty(e.target.value)
                break
                
            case 'desc':
                setDesc(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Event has been recorded', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('recordSpoilageOrDamage', {
        item: record?.item?._id,
        store: store?._id,
        quantity,
        description
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Recording event...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Record Spoilage / Damage"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-1">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many { record?.item?.issuedIn }?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        name="qty"
                        onChange={ modify }
                        placeholder="50" />
                </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Description
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-desc"
                        rows="5"
                        name="desc"
                        onChange={ modify }
                        placeholder="Describe the spoilage / damage" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={execute } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default RecordSpoilage